export const theme = {
  primary: '#531dab',
  primaryLight: '#f3e8fe',
  shadow: 'rgba(83, 29, 171, 0.08)',
  gradient: 'linear-gradient(125deg, #1a0a3d 0%, #3d1578 42%, #531dab 100%)',
  overlay: 'radial-gradient(ellipse 50% 60% at 85% 40%, rgba(160, 120, 255, 0.15) 0%, transparent 55%)'
}

export const pageMeta = {
  title: '综合治理管理系统',
  badge: '数字化赋能基层治理',
  description:
    '融合网格化管理、事件处置、矛盾调解、视频监控与指挥调度，打造"发现—上报—分派—处置—反馈"闭环治理平台，提升基层社会治理现代化水平。',
  stats: [
    { value: '网格', label: '精细管理' },
    { value: '事件', label: '闭环处置' },
    { value: '调度', label: '指挥联动' },
    { value: '100%', label: '安全合规' }
  ]
}

export const sections = {
  features: {
    title: '核心功能',
    desc: '六大功能模块覆盖综合治理全流程，以数字化技术驱动基层社会治理提质增效。'
  },
  whyUs: {
    title: '为什么选择我们',
    desc: '深耕基层社会治理信息化领域多年，以技术实力与行业经验赢得客户信赖。'
  },
  related: {
    title: '相关产品',
    desc: '探索更多小智科技政务数字化解决方案。'
  }
}

export const features = [
  {
    icon: '🗺️',
    title: '网格化管理',
    desc: '划分责任网格，明确网格员职责，实现人、地、事、物、组织全要素管理，构建"横到边、纵到底"的治理网络。'
  },
  {
    icon: '📋',
    title: '事件闭环处置',
    desc: '支持群众上报、巡查发现、上级交办等多渠道事件接入，自动分派、限时处置、督办催办，全程留痕可追溯。'
  },
  {
    icon: '🤝',
    title: '矛盾调解管理',
    desc: '记录矛盾纠纷受理、调解、回访全流程，支持分类分级管理，辅助排查化解社会矛盾，维护社会稳定。'
  },
  {
    icon: '📹',
    title: '视频监控联动',
    desc: '对接雪亮工程、天网工程等视频监控资源，支持实时查看、录像回放与事件关联，提升可视化指挥能力。'
  },
  {
    icon: '📣',
    title: '民意收集反馈',
    desc: '整合12345热线、随手拍、网格员走访等民意渠道，统一受理、分类转办、限时反馈，提升群众满意度。'
  },
  {
    icon: '🎯',
    title: '指挥调度中心',
    desc: '可视化呈现辖区事件态势、资源分布与处置进度，支持一键调度、视频会议与应急指挥，实现平战结合。'
  }
]

export const architecture = {
  variant: 'gov-bar',
  title: '综合治理方案',
  desc: '综合治理方案采用"展示—用户—平台—业务支撑—数据资源—基础设施"六层架构，构建安全可控、灵活扩展的数字化治理体系。',
  layers: [
    {
      name: '展示层',
      items: [
        '综合管理后台',
        '网格管理平台',
        '综合指挥调度平台',
        '智能研判平台',
        '移动指挥平台'
      ]
    },
    {
      name: '用户层',
      items: [
        '领导小组成员',
        '指挥中心工作人员',
        '单位/乡镇工作人员',
        '网格员',
        '居民'
      ]
    },
    {
      name: '平台层',
      groups: [
        {
          items: [
            '网格管理',
            '居民管理',
            '乡镇管理',
            '工作人员管理',
            '案件汇聚管理',
            '案件审批管理',
            '重点区域/人群管理',
            '结案回访管理',
            '意见征集',
            '数据治理',
            'BI报表',
            '审核'
          ]
        },
        {
          name: '智能研判',
          items: [
            '数据挖掘与数据学习',
            '风险研判模型',
            '重点人群归类模型'
          ]
        },
        {
          name: '联动平台',
          items: [
            '指挥调度',
            '移动工作平台',
            '移动执法平台'
          ]
        }
      ]
    },
    {
      name: '业务支撑层',
      footer: '统一应用支持平台',
      items: [
        '统一认证',
        '统一消息',
        '统一任务',
        '统一应用集成',
        'BI报表',
        '专业模型'
      ]
    },
    {
      name: '数据资源层',
      header: '数据共享交换',
      items: [
        '数据接入',
        '数据治理',
        '数据资源池',
        '数据质量',
        '数据标准'
      ]
    },
    {
      name: '基础设施层',
      items: [
        '政务云平台',
        '电子政务外网',
        '物联网'
      ]
    }
  ],
  footer: '数据共享交换 · 数据安全 · 等保测评 · 私有化部署'
}

export const whyUs = [
  {
    title: '标准规范',
    desc: '对标中央及省市关于基层社会治理现代化相关政策要求，功能设计符合网格化管理标准规范。'
  },
  {
    title: '闭环管理',
    desc: '事件从发现到办结全流程线上管理，超时自动预警、督办催办，确保"件件有着落、事事有回音"。'
  },
  {
    title: '实战验证',
    desc: '已在湖北省多个区县、街道、乡镇成功落地，覆盖城市社区与农村网格等多种治理场景。'
  },
  {
    title: '快速部署',
    desc: '模块化架构设计，支持灵活配置与快速上线，提供专属实施团队与7×24运维保障服务。'
  }
]

export const scenarios = {
  label: '治理落地场景',
  title: '让网格管理、事件处置和矛盾调解更有章法',
  desc: '系统定位为"综合治理工具"，帮助基层工作人员从繁杂的事务协调中解放出来，提升治理效率与群众获得感。',
  items: [
    {
      title: '网格巡查常态化',
      desc: '网格员每日巡查打卡，发现问题随手拍上报，系统自动分派责任单位，限时处置并反馈结果。'
    },
    {
      title: '矛盾纠纷早化解',
      desc: '矛盾纠纷登记、分类、调解、回访全流程管理，重大矛盾预警上报，防止小事拖大、大事拖炸。'
    },
    {
      title: '民意诉求快响应',
      desc: '整合多渠道民意诉求，统一受理分办，处置进度实时可查，提升群众对政府工作的满意度。'
    },
    {
      title: '应急指挥高效率',
      desc: '突发事件一键上报，指挥大屏实时掌握态势，快速调度人员与资源，实现高效协同处置。'
    }
  ],
  highlights: [
    { title: '多端协同', desc: '支持PC端、手机端、平板端协同办公，网格员外出巡查也能随时处理事件。' },
    { title: '规则可配置', desc: '可按本地治理规范配置网格层级、事件分类、处置流程与考核指标，灵活适配。' },
    { title: '数据可视化', desc: '治理态势一屏呈现，辅助领导掌握辖区动态、发现薄弱环节、科学决策。' }
  ]
}

export const relatedProducts = [
  {
    icon: '🔍',
    title: '智慧巡检',
    desc: '摄像头+无人机+AI算法+广播驱离，空地协同智能识别，事件调度处置业务闭环。',
    route: '/smart-inspection',
    color: '#d48806'
  },
  {
    icon: '🌾',
    title: '数字乡村',
    desc: '乡村治理、智慧农业、便民服务、产业振兴全流程数字化，助力乡村振兴战略落地见效。',
    route: '/digital-village',
    color: '#0a6e4e'
  },
  {
    icon: '👔',
    title: '干部管理',
    desc: '基于AI的干部全生命周期管理平台，涵盖选拔、考核、培养、监督等环节。',
    route: '/cadre-management',
    color: '#0052d9'
  }
]
